import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.array.filter";
import _toConsumableArray from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.function.name";
import _defineProperty from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.promise";
import _regeneratorRuntime from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

var _ERRORS;

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { _getProvider, getApp, _registerComponent, registerVersion } from '@firebase/app';
import { Component } from '@firebase/component';
import { Deferred, ErrorFactory, isIndexedDBAvailable, uuidv4, getGlobal, base64, issuedAtTime, calculateBackoffMillis, getModularInstance } from '@firebase/util';
import { Logger } from '@firebase/logger';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var APP_CHECK_STATES = new Map();
var DEFAULT_STATE = {
  activated: false,
  tokenObservers: []
};
var DEBUG_STATE = {
  initialized: false,
  enabled: false
};
/**
 * Gets a reference to the state object.
 */

function getStateReference(app) {
  return APP_CHECK_STATES.get(app) || Object.assign({}, DEFAULT_STATE);
}
/**
 * Set once on initialization. The map should hold the same reference to the
 * same object until this entry is deleted.
 */


function setInitialState(app, state) {
  APP_CHECK_STATES.set(app, state);
  return APP_CHECK_STATES.get(app);
}

function getDebugState() {
  return DEBUG_STATE;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var BASE_ENDPOINT = 'https://content-firebaseappcheck.googleapis.com/v1';
var EXCHANGE_RECAPTCHA_TOKEN_METHOD = 'exchangeRecaptchaV3Token';
var EXCHANGE_RECAPTCHA_ENTERPRISE_TOKEN_METHOD = 'exchangeRecaptchaEnterpriseToken';
var EXCHANGE_DEBUG_TOKEN_METHOD = 'exchangeDebugToken';
var TOKEN_REFRESH_TIME = {
  /**
   * The offset time before token natural expiration to run the refresh.
   * This is currently 5 minutes.
   */
  OFFSET_DURATION: 5 * 60 * 1000,

  /**
   * This is the first retrial wait after an error. This is currently
   * 30 seconds.
   */
  RETRIAL_MIN_WAIT: 30 * 1000,

  /**
   * This is the maximum retrial wait, currently 16 minutes.
   */
  RETRIAL_MAX_WAIT: 16 * 60 * 1000
};
/**
 * One day in millis, for certain error code backoffs.
 */

var ONE_DAY = 24 * 60 * 60 * 1000;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Port from auth proactiverefresh.js
 *
 */
// TODO: move it to @firebase/util?
// TODO: allow to config whether refresh should happen in the background

var Refresher = /*#__PURE__*/function () {
  function Refresher(operation, retryPolicy, getWaitDuration, lowerBound, upperBound) {
    _classCallCheck(this, Refresher);

    this.operation = operation;
    this.retryPolicy = retryPolicy;
    this.getWaitDuration = getWaitDuration;
    this.lowerBound = lowerBound;
    this.upperBound = upperBound;
    this.pending = null;
    this.nextErrorWaitInterval = lowerBound;

    if (lowerBound > upperBound) {
      throw new Error('Proactive refresh lower bound greater than upper bound!');
    }
  }

  _createClass(Refresher, [{
    key: "start",
    value: function start() {
      this.nextErrorWaitInterval = this.lowerBound;
      this.process(true)["catch"](function () {
        /* we don't care about the result */
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.pending) {
        this.pending.reject('cancelled');
        this.pending = null;
      }
    }
  }, {
    key: "isRunning",
    value: function isRunning() {
      return !!this.pending;
    }
  }, {
    key: "process",
    value: function () {
      var _process = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hasSucceeded) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.stop();
                _context.prev = 1;
                this.pending = new Deferred();
                _context.next = 5;
                return sleep(this.getNextRun(hasSucceeded));

              case 5:
                // Why do we resolve a promise, then immediate wait for it?
                // We do it to make the promise chain cancellable.
                // We can call stop() which rejects the promise before the following line execute, which makes
                // the code jump to the catch block.
                // TODO: unit test this
                this.pending.resolve();
                _context.next = 8;
                return this.pending.promise;

              case 8:
                this.pending = new Deferred();
                _context.next = 11;
                return this.operation();

              case 11:
                this.pending.resolve();
                _context.next = 14;
                return this.pending.promise;

              case 14:
                this.process(true)["catch"](function () {
                  /* we don't care about the result */
                });
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](1);

                if (this.retryPolicy(_context.t0)) {
                  this.process(false)["catch"](function () {
                    /* we don't care about the result */
                  });
                } else {
                  this.stop();
                }

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 17]]);
      }));

      function process(_x) {
        return _process.apply(this, arguments);
      }

      return process;
    }()
  }, {
    key: "getNextRun",
    value: function getNextRun(hasSucceeded) {
      if (hasSucceeded) {
        // If last operation succeeded, reset next error wait interval and return
        // the default wait duration.
        this.nextErrorWaitInterval = this.lowerBound; // Return typical wait duration interval after a successful operation.

        return this.getWaitDuration();
      } else {
        // Get next error wait interval.
        var currentErrorWaitInterval = this.nextErrorWaitInterval; // Double interval for next consecutive error.

        this.nextErrorWaitInterval *= 2; // Make sure next wait interval does not exceed the maximum upper bound.

        if (this.nextErrorWaitInterval > this.upperBound) {
          this.nextErrorWaitInterval = this.upperBound;
        }

        return currentErrorWaitInterval;
      }
    }
  }]);

  return Refresher;
}();

function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ERRORS = (_ERRORS = {}, _defineProperty(_ERRORS, "already-initialized"
/* AppCheckError.ALREADY_INITIALIZED */
, 'You have already called initializeAppCheck() for FirebaseApp {$appName} with ' + 'different options. To avoid this error, call initializeAppCheck() with the ' + 'same options as when it was originally called. This will return the ' + 'already initialized instance.'), _defineProperty(_ERRORS, "use-before-activation"
/* AppCheckError.USE_BEFORE_ACTIVATION */
, 'App Check is being used before initializeAppCheck() is called for FirebaseApp {$appName}. ' + 'Call initializeAppCheck() before instantiating other Firebase services.'), _defineProperty(_ERRORS, "fetch-network-error"
/* AppCheckError.FETCH_NETWORK_ERROR */
, 'Fetch failed to connect to a network. Check Internet connection. ' + 'Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "fetch-parse-error"
/* AppCheckError.FETCH_PARSE_ERROR */
, 'Fetch client could not parse response.' + ' Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "fetch-status-error"
/* AppCheckError.FETCH_STATUS_ERROR */
, 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.'), _defineProperty(_ERRORS, "storage-open"
/* AppCheckError.STORAGE_OPEN */
, 'Error thrown when opening storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "storage-get"
/* AppCheckError.STORAGE_GET */
, 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "storage-set"
/* AppCheckError.STORAGE_WRITE */
, 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "recaptcha-error"
/* AppCheckError.RECAPTCHA_ERROR */
, 'ReCAPTCHA error.'), _defineProperty(_ERRORS, "throttled"
/* AppCheckError.THROTTLED */
, "Requests throttled due to {$httpStatus} error. Attempts allowed again after {$time}"), _ERRORS);
var ERROR_FACTORY = new ErrorFactory('appCheck', 'AppCheck', ERRORS);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function getRecaptcha() {
  var isEnterprise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _a;

  if (isEnterprise) {
    return (_a = self.grecaptcha) === null || _a === void 0 ? void 0 : _a.enterprise;
  }

  return self.grecaptcha;
}

function ensureActivated(app) {
  if (!getStateReference(app).activated) {
    throw ERROR_FACTORY.create("use-before-activation"
    /* AppCheckError.USE_BEFORE_ACTIVATION */
    , {
      appName: app.name
    });
  }
}

function getDurationString(durationInMillis) {
  var totalSeconds = Math.round(durationInMillis / 1000);
  var days = Math.floor(totalSeconds / (3600 * 24));
  var hours = Math.floor((totalSeconds - days * 3600 * 24) / 3600);
  var minutes = Math.floor((totalSeconds - days * 3600 * 24 - hours * 3600) / 60);
  var seconds = totalSeconds - days * 3600 * 24 - hours * 3600 - minutes * 60;
  var result = '';

  if (days) {
    result += pad(days) + 'd:';
  }

  if (hours) {
    result += pad(hours) + 'h:';
  }

  result += pad(minutes) + 'm:' + pad(seconds) + 's';
  return result;
}

function pad(value) {
  if (value === 0) {
    return '00';
  }

  return value >= 10 ? value.toString() : '0' + value;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function exchangeToken(_x2, _x3) {
  return _exchangeToken.apply(this, arguments);
}

function _exchangeToken() {
  _exchangeToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref, heartbeatServiceProvider) {
    var url, body, headers, heartbeatService, heartbeatsHeader, options, response, responseBody, match, timeToLiveAsNumber, now;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            url = _ref.url, body = _ref.body;
            headers = {
              'Content-Type': 'application/json'
            }; // If heartbeat service exists, add heartbeat header string to the header.

            heartbeatService = heartbeatServiceProvider.getImmediate({
              optional: true
            });

            if (!heartbeatService) {
              _context6.next = 8;
              break;
            }

            _context6.next = 6;
            return heartbeatService.getHeartbeatsHeader();

          case 6:
            heartbeatsHeader = _context6.sent;

            if (heartbeatsHeader) {
              headers['X-Firebase-Client'] = heartbeatsHeader;
            }

          case 8:
            options = {
              method: 'POST',
              body: JSON.stringify(body),
              headers: headers
            };
            _context6.prev = 9;
            _context6.next = 12;
            return fetch(url, options);

          case 12:
            response = _context6.sent;
            _context6.next = 18;
            break;

          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](9);
            throw ERROR_FACTORY.create("fetch-network-error"
            /* AppCheckError.FETCH_NETWORK_ERROR */
            , {
              originalErrorMessage: _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.message
            });

          case 18:
            if (!(response.status !== 200)) {
              _context6.next = 20;
              break;
            }

            throw ERROR_FACTORY.create("fetch-status-error"
            /* AppCheckError.FETCH_STATUS_ERROR */
            , {
              httpStatus: response.status
            });

          case 20:
            _context6.prev = 20;
            _context6.next = 23;
            return response.json();

          case 23:
            responseBody = _context6.sent;
            _context6.next = 29;
            break;

          case 26:
            _context6.prev = 26;
            _context6.t1 = _context6["catch"](20);
            throw ERROR_FACTORY.create("fetch-parse-error"
            /* AppCheckError.FETCH_PARSE_ERROR */
            , {
              originalErrorMessage: _context6.t1 === null || _context6.t1 === void 0 ? void 0 : _context6.t1.message
            });

          case 29:
            // Protobuf duration format.
            // https://developers.google.com/protocol-buffers/docs/reference/java/com/google/protobuf/Duration
            match = responseBody.ttl.match(/^([\d.]+)(s)$/);

            if (!(!match || !match[2] || isNaN(Number(match[1])))) {
              _context6.next = 32;
              break;
            }

            throw ERROR_FACTORY.create("fetch-parse-error"
            /* AppCheckError.FETCH_PARSE_ERROR */
            , {
              originalErrorMessage: "ttl field (timeToLive) is not in standard Protobuf Duration " + "format: ".concat(responseBody.ttl)
            });

          case 32:
            timeToLiveAsNumber = Number(match[1]) * 1000;
            now = Date.now();
            return _context6.abrupt("return", {
              token: responseBody.token,
              expireTimeMillis: now + timeToLiveAsNumber,
              issuedAtTimeMillis: now
            });

          case 35:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[9, 15], [20, 26]]);
  }));
  return _exchangeToken.apply(this, arguments);
}

function getExchangeRecaptchaV3TokenRequest(app, reCAPTCHAToken) {
  var _app$options = app.options,
      projectId = _app$options.projectId,
      appId = _app$options.appId,
      apiKey = _app$options.apiKey;
  return {
    url: "".concat(BASE_ENDPOINT, "/projects/").concat(projectId, "/apps/").concat(appId, ":").concat(EXCHANGE_RECAPTCHA_TOKEN_METHOD, "?key=").concat(apiKey),
    body: {
      'recaptcha_v3_token': reCAPTCHAToken
    }
  };
}

function getExchangeRecaptchaEnterpriseTokenRequest(app, reCAPTCHAToken) {
  var _app$options2 = app.options,
      projectId = _app$options2.projectId,
      appId = _app$options2.appId,
      apiKey = _app$options2.apiKey;
  return {
    url: "".concat(BASE_ENDPOINT, "/projects/").concat(projectId, "/apps/").concat(appId, ":").concat(EXCHANGE_RECAPTCHA_ENTERPRISE_TOKEN_METHOD, "?key=").concat(apiKey),
    body: {
      'recaptcha_enterprise_token': reCAPTCHAToken
    }
  };
}

function getExchangeDebugTokenRequest(app, debugToken) {
  var _app$options3 = app.options,
      projectId = _app$options3.projectId,
      appId = _app$options3.appId,
      apiKey = _app$options3.apiKey;
  return {
    url: "".concat(BASE_ENDPOINT, "/projects/").concat(projectId, "/apps/").concat(appId, ":").concat(EXCHANGE_DEBUG_TOKEN_METHOD, "?key=").concat(apiKey),
    body: {
      // eslint-disable-next-line
      debug_token: debugToken
    }
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DB_NAME = 'firebase-app-check-database';
var DB_VERSION = 1;
var STORE_NAME = 'firebase-app-check-store';
var DEBUG_TOKEN_KEY = 'debug-token';
var dbPromise = null;

function getDBPromise() {
  if (dbPromise) {
    return dbPromise;
  }

  dbPromise = new Promise(function (resolve, reject) {
    try {
      var request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onsuccess = function (event) {
        resolve(event.target.result);
      };

      request.onerror = function (event) {
        var _a;

        reject(ERROR_FACTORY.create("storage-open"
        /* AppCheckError.STORAGE_OPEN */
        , {
          originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
        }));
      };

      request.onupgradeneeded = function (event) {
        var db = event.target.result; // We don't use 'break' in this switch statement, the fall-through
        // behavior is what we want, because if there are multiple versions between
        // the old version and the current version, we want ALL the migrations
        // that correspond to those versions to run, not only the last one.
        // eslint-disable-next-line default-case

        switch (event.oldVersion) {
          case 0:
            db.createObjectStore(STORE_NAME, {
              keyPath: 'compositeKey'
            });
        }
      };
    } catch (e) {
      reject(ERROR_FACTORY.create("storage-open"
      /* AppCheckError.STORAGE_OPEN */
      , {
        originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
      }));
    }
  });
  return dbPromise;
}

function readTokenFromIndexedDB(app) {
  return read(computeKey(app));
}

function writeTokenToIndexedDB(app, token) {
  return write(computeKey(app), token);
}

function writeDebugTokenToIndexedDB(token) {
  return write(DEBUG_TOKEN_KEY, token);
}

function readDebugTokenFromIndexedDB() {
  return read(DEBUG_TOKEN_KEY);
}

function write(_x4, _x5) {
  return _write.apply(this, arguments);
}

function _write() {
  _write = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(key, value) {
    var db, transaction, store, request;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getDBPromise();

          case 2:
            db = _context7.sent;
            transaction = db.transaction(STORE_NAME, 'readwrite');
            store = transaction.objectStore(STORE_NAME);
            request = store.put({
              compositeKey: key,
              value: value
            });
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function (_event) {
                resolve();
              };

              transaction.onerror = function (event) {
                var _a;

                reject(ERROR_FACTORY.create("storage-set"
                /* AppCheckError.STORAGE_WRITE */
                , {
                  originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
                }));
              };
            }));

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _write.apply(this, arguments);
}

function read(_x6) {
  return _read.apply(this, arguments);
}

function _read() {
  _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(key) {
    var db, transaction, store, request;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return getDBPromise();

          case 2:
            db = _context8.sent;
            transaction = db.transaction(STORE_NAME, 'readonly');
            store = transaction.objectStore(STORE_NAME);
            request = store.get(key);
            return _context8.abrupt("return", new Promise(function (resolve, reject) {
              request.onsuccess = function (event) {
                var result = event.target.result;

                if (result) {
                  resolve(result.value);
                } else {
                  resolve(undefined);
                }
              };

              transaction.onerror = function (event) {
                var _a;

                reject(ERROR_FACTORY.create("storage-get"
                /* AppCheckError.STORAGE_GET */
                , {
                  originalErrorMessage: (_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message
                }));
              };
            }));

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _read.apply(this, arguments);
}

function computeKey(app) {
  return "".concat(app.options.appId, "-").concat(app.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var logger = new Logger('@firebase/app-check');
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Always resolves. In case of an error reading from indexeddb, resolve with undefined
 */

function readTokenFromStorage(_x7) {
  return _readTokenFromStorage.apply(this, arguments);
}
/**
 * Always resolves. In case of an error writing to indexeddb, print a warning and resolve the promise
 */


function _readTokenFromStorage() {
  _readTokenFromStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(app) {
    var token;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!isIndexedDBAvailable()) {
              _context9.next = 12;
              break;
            }

            token = undefined;
            _context9.prev = 2;
            _context9.next = 5;
            return readTokenFromIndexedDB(app);

          case 5:
            token = _context9.sent;
            _context9.next = 11;
            break;

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](2);
            // swallow the error and return undefined
            logger.warn("Failed to read token from IndexedDB. Error: ".concat(_context9.t0));

          case 11:
            return _context9.abrupt("return", token);

          case 12:
            return _context9.abrupt("return", undefined);

          case 13:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[2, 8]]);
  }));
  return _readTokenFromStorage.apply(this, arguments);
}

function writeTokenToStorage(app, token) {
  if (isIndexedDBAvailable()) {
    return writeTokenToIndexedDB(app, token)["catch"](function (e) {
      // swallow the error and resolve the promise
      logger.warn("Failed to write token to IndexedDB. Error: ".concat(e));
    });
  }

  return Promise.resolve();
}

function readOrCreateDebugTokenFromStorage() {
  return _readOrCreateDebugTokenFromStorage.apply(this, arguments);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function _readOrCreateDebugTokenFromStorage() {
  _readOrCreateDebugTokenFromStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var existingDebugToken, newToken;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            /**
             * Theoretically race condition can happen if we read, then write in 2 separate transactions.
             * But it won't happen here, because this function will be called exactly once.
             */
            existingDebugToken = undefined;
            _context10.prev = 1;
            _context10.next = 4;
            return readDebugTokenFromIndexedDB();

          case 4:
            existingDebugToken = _context10.sent;
            _context10.next = 9;
            break;

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](1);

          case 9:
            if (existingDebugToken) {
              _context10.next = 15;
              break;
            }

            // create a new debug token
            newToken = uuidv4(); // We don't need to block on writing to indexeddb
            // In case persistence failed, a new debug token will be generated everytime the page is refreshed.
            // It renders the debug token useless because you have to manually register(whitelist) the new token in the firebase console again and again.
            // If you see this error trying to use debug token, it probably means you are using a browser that doesn't support indexeddb.
            // You should switch to a different browser that supports indexeddb

            writeDebugTokenToIndexedDB(newToken)["catch"](function (e) {
              return logger.warn("Failed to persist debug token to IndexedDB. Error: ".concat(e));
            });
            return _context10.abrupt("return", newToken);

          case 15:
            return _context10.abrupt("return", existingDebugToken);

          case 16:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 7]]);
  }));
  return _readOrCreateDebugTokenFromStorage.apply(this, arguments);
}

function isDebugMode() {
  var debugState = getDebugState();
  return debugState.enabled;
}

function getDebugToken() {
  return _getDebugToken.apply(this, arguments);
}

function _getDebugToken() {
  _getDebugToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var state;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            state = getDebugState();

            if (!(state.enabled && state.token)) {
              _context11.next = 5;
              break;
            }

            return _context11.abrupt("return", state.token.promise);

          case 5:
            throw Error("\n            Can't get debug token in production mode.\n        ");

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _getDebugToken.apply(this, arguments);
}

function initializeDebugMode() {
  var globals = getGlobal();
  var debugState = getDebugState(); // Set to true if this function has been called, whether or not
  // it enabled debug mode.

  debugState.initialized = true;

  if (typeof globals.FIREBASE_APPCHECK_DEBUG_TOKEN !== 'string' && globals.FIREBASE_APPCHECK_DEBUG_TOKEN !== true) {
    return;
  }

  debugState.enabled = true;
  var deferredToken = new Deferred();
  debugState.token = deferredToken;

  if (typeof globals.FIREBASE_APPCHECK_DEBUG_TOKEN === 'string') {
    deferredToken.resolve(globals.FIREBASE_APPCHECK_DEBUG_TOKEN);
  } else {
    deferredToken.resolve(readOrCreateDebugTokenFromStorage());
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Initial hardcoded value agreed upon across platforms for initial launch.
// Format left open for possible dynamic error values and other fields in the future.


var defaultTokenErrorData = {
  error: 'UNKNOWN_ERROR'
};
/**
 * Stringify and base64 encode token error data.
 *
 * @param tokenError Error data, currently hardcoded.
 */

function formatDummyToken(tokenErrorData) {
  return base64.encodeString(JSON.stringify(tokenErrorData),
  /* webSafe= */
  false);
}
/**
 * This function always resolves.
 * The result will contain an error field if there is any error.
 * In case there is an error, the token field in the result will be populated with a dummy value
 */


function getToken$2(_x8) {
  return _getToken$.apply(this, arguments);
}

function _getToken$() {
  _getToken$ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(appCheck) {
    var forceRefresh,
        app,
        state,
        token,
        error,
        cachedToken,
        shouldCallListeners,
        tokenFromDebugExchange,
        interopTokenResult,
        _args12 = arguments;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            forceRefresh = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : false;
            app = appCheck.app;
            ensureActivated(app);
            state = getStateReference(app);
            /**
             * First check if there is a token in memory from a previous `getToken()` call.
             */

            token = state.token;
            error = undefined;
            /**
             * If an invalid token was found in memory, clear token from
             * memory and unset the local variable `token`.
             */

            if (token && !isValid(token)) {
              state.token = undefined;
              token = undefined;
            }
            /**
             * If there is no valid token in memory, try to load token from indexedDB.
             */


            if (token) {
              _context12.next = 18;
              break;
            }

            _context12.next = 10;
            return state.cachedTokenPromise;

          case 10:
            cachedToken = _context12.sent;

            if (!cachedToken) {
              _context12.next = 18;
              break;
            }

            if (!isValid(cachedToken)) {
              _context12.next = 16;
              break;
            }

            token = cachedToken;
            _context12.next = 18;
            break;

          case 16:
            _context12.next = 18;
            return writeTokenToStorage(app, undefined);

          case 18:
            if (!(!forceRefresh && token && isValid(token))) {
              _context12.next = 20;
              break;
            }

            return _context12.abrupt("return", {
              token: token.token
            });

          case 20:
            // Only set to true if this `getToken()` call is making the actual
            // REST call to the exchange endpoint, versus waiting for an already
            // in-flight call (see debug and regular exchange endpoint paths below)
            shouldCallListeners = false;
            /**
             * DEBUG MODE
             * If debug mode is set, and there is no cached token, fetch a new App
             * Check token using the debug token, and return it directly.
             */

            if (!isDebugMode()) {
              _context12.next = 40;
              break;
            }

            if (state.exchangeTokenPromise) {
              _context12.next = 33;
              break;
            }

            _context12.t0 = exchangeToken;
            _context12.t1 = getExchangeDebugTokenRequest;
            _context12.t2 = app;
            _context12.next = 28;
            return getDebugToken();

          case 28:
            _context12.t3 = _context12.sent;
            _context12.t4 = (0, _context12.t1)(_context12.t2, _context12.t3);
            _context12.t5 = appCheck.heartbeatServiceProvider;
            state.exchangeTokenPromise = (0, _context12.t0)(_context12.t4, _context12.t5)["finally"](function () {
              // Clear promise when settled - either resolved or rejected.
              state.exchangeTokenPromise = undefined;
            });
            shouldCallListeners = true;

          case 33:
            _context12.next = 35;
            return state.exchangeTokenPromise;

          case 35:
            tokenFromDebugExchange = _context12.sent;
            _context12.next = 38;
            return writeTokenToStorage(app, tokenFromDebugExchange);

          case 38:
            // Write debug token to state.
            state.token = tokenFromDebugExchange;
            return _context12.abrupt("return", {
              token: tokenFromDebugExchange.token
            });

          case 40:
            _context12.prev = 40;

            // Avoid making another call to the exchange endpoint if one is in flight.
            if (!state.exchangeTokenPromise) {
              // state.provider is populated in initializeAppCheck()
              // ensureActivated() at the top of this function checks that
              // initializeAppCheck() has been called.
              state.exchangeTokenPromise = state.provider.getToken()["finally"](function () {
                // Clear promise when settled - either resolved or rejected.
                state.exchangeTokenPromise = undefined;
              });
              shouldCallListeners = true;
            }

            _context12.next = 44;
            return getStateReference(app).exchangeTokenPromise;

          case 44:
            token = _context12.sent;
            _context12.next = 51;
            break;

          case 47:
            _context12.prev = 47;
            _context12.t6 = _context12["catch"](40);

            if (_context12.t6.code === "appCheck/".concat("throttled"
            /* AppCheckError.THROTTLED */
            )) {
              // Warn if throttled, but do not treat it as an error.
              logger.warn(_context12.t6.message);
            } else {
              // `getToken()` should never throw, but logging error text to console will aid debugging.
              logger.error(_context12.t6);
            } // Always save error to be added to dummy token.


            error = _context12.t6;

          case 51:
            if (token) {
              _context12.next = 55;
              break;
            }

            // If token is undefined, there must be an error.
            // Return a dummy token along with the error.
            interopTokenResult = makeDummyTokenResult(error);
            _context12.next = 63;
            break;

          case 55:
            if (!error) {
              _context12.next = 59;
              break;
            }

            if (isValid(token)) {
              // It's also possible a valid token exists, but there's also an error.
              // (Such as if the token is almost expired, tries to refresh, and
              // the exchange request fails.)
              // We add a special error property here so that the refresher will
              // count this as a failed attempt and use the backoff instead of
              // retrying repeatedly with no delay, but any 3P listeners will not
              // be hindered in getting the still-valid token.
              interopTokenResult = {
                token: token.token,
                internalError: error
              };
            } else {
              // No invalid tokens should make it to this step. Memory and cached tokens
              // are checked. Other tokens are from fresh exchanges. But just in case.
              interopTokenResult = makeDummyTokenResult(error);
            }

            _context12.next = 63;
            break;

          case 59:
            interopTokenResult = {
              token: token.token
            }; // write the new token to the memory state as well as the persistent storage.
            // Only do it if we got a valid new token

            state.token = token;
            _context12.next = 63;
            return writeTokenToStorage(app, token);

          case 63:
            if (shouldCallListeners) {
              notifyTokenListeners(app, interopTokenResult);
            }

            return _context12.abrupt("return", interopTokenResult);

          case 65:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[40, 47]]);
  }));
  return _getToken$.apply(this, arguments);
}

function _addTokenListener(appCheck, type, listener, onError) {
  var app = appCheck.app;
  var state = getStateReference(app);
  var tokenObserver = {
    next: listener,
    error: onError,
    type: type
  };
  state.tokenObservers = [].concat(_toConsumableArray(state.tokenObservers), [tokenObserver]); // Invoke the listener async immediately if there is a valid token
  // in memory.

  if (state.token && isValid(state.token)) {
    var validToken = state.token;
    Promise.resolve().then(function () {
      listener({
        token: validToken.token
      });
      initTokenRefresher(appCheck);
    })["catch"](function () {
      /* we don't care about exceptions thrown in listeners */
    });
  }
  /**
   * Wait for any cached token promise to resolve before starting the token
   * refresher. The refresher checks to see if there is an existing token
   * in state and calls the exchange endpoint if not. We should first let the
   * IndexedDB check have a chance to populate state if it can.
   *
   * Listener call isn't needed here because cachedTokenPromise will call any
   * listeners that exist when it resolves.
   */
  // state.cachedTokenPromise is always populated in `activate()`.


  void state.cachedTokenPromise.then(function () {
    return initTokenRefresher(appCheck);
  });
}

function _removeTokenListener(app, listener) {
  var state = getStateReference(app);
  var newObservers = state.tokenObservers.filter(function (tokenObserver) {
    return tokenObserver.next !== listener;
  });

  if (newObservers.length === 0 && state.tokenRefresher && state.tokenRefresher.isRunning()) {
    state.tokenRefresher.stop();
  }

  state.tokenObservers = newObservers;
}
/**
 * Logic to create and start refresher as needed.
 */


function initTokenRefresher(appCheck) {
  var app = appCheck.app;
  var state = getStateReference(app); // Create the refresher but don't start it if `isTokenAutoRefreshEnabled`
  // is not true.

  var refresher = state.tokenRefresher;

  if (!refresher) {
    refresher = createTokenRefresher(appCheck);
    state.tokenRefresher = refresher;
  }

  if (!refresher.isRunning() && state.isTokenAutoRefreshEnabled) {
    refresher.start();
  }
}

function createTokenRefresher(appCheck) {
  var app = appCheck.app;
  return new Refresher(
  /*#__PURE__*/
  // Keep in mind when this fails for any reason other than the ones
  // for which we should retry, it will effectively stop the proactive refresh.
  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var state, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            state = getStateReference(app); // If there is no token, we will try to load it from storage and use it
            // If there is a token, we force refresh it because we know it's going to expire soon

            if (state.token) {
              _context2.next = 7;
              break;
            }

            _context2.next = 4;
            return getToken$2(appCheck);

          case 4:
            result = _context2.sent;
            _context2.next = 10;
            break;

          case 7:
            _context2.next = 9;
            return getToken$2(appCheck, true);

          case 9:
            result = _context2.sent;

          case 10:
            if (!result.error) {
              _context2.next = 12;
              break;
            }

            throw result.error;

          case 12:
            if (!result.internalError) {
              _context2.next = 14;
              break;
            }

            throw result.internalError;

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), function () {
    return true;
  }, function () {
    var state = getStateReference(app);

    if (state.token) {
      // issuedAtTime + (50% * total TTL) + 5 minutes
      var nextRefreshTimeMillis = state.token.issuedAtTimeMillis + (state.token.expireTimeMillis - state.token.issuedAtTimeMillis) * 0.5 + 5 * 60 * 1000; // Do not allow refresh time to be past (expireTime - 5 minutes)

      var latestAllowableRefresh = state.token.expireTimeMillis - 5 * 60 * 1000;
      nextRefreshTimeMillis = Math.min(nextRefreshTimeMillis, latestAllowableRefresh);
      return Math.max(0, nextRefreshTimeMillis - Date.now());
    } else {
      return 0;
    }
  }, TOKEN_REFRESH_TIME.RETRIAL_MIN_WAIT, TOKEN_REFRESH_TIME.RETRIAL_MAX_WAIT);
}

function notifyTokenListeners(app, token) {
  var observers = getStateReference(app).tokenObservers;

  var _iterator = _createForOfIteratorHelper(observers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var observer = _step.value;

      try {
        if (observer.type === "EXTERNAL"
        /* ListenerType.EXTERNAL */
        && token.error != null) {
          // If this listener was added by a 3P call, send any token error to
          // the supplied error handler. A 3P observer always has an error
          // handler.
          observer.error(token.error);
        } else {
          // If the token has no error field, always return the token.
          // If this is a 2P listener, return the token, whether or not it
          // has an error field.
          observer.next(token);
        }
      } catch (e) {// Errors in the listener function itself are always ignored.
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

function isValid(token) {
  return token.expireTimeMillis - Date.now() > 0;
}

function makeDummyTokenResult(error) {
  return {
    token: formatDummyToken(defaultTokenErrorData),
    error: error
  };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * AppCheck Service class.
 */


var AppCheckService = /*#__PURE__*/function () {
  function AppCheckService(app, heartbeatServiceProvider) {
    _classCallCheck(this, AppCheckService);

    this.app = app;
    this.heartbeatServiceProvider = heartbeatServiceProvider;
  }

  _createClass(AppCheckService, [{
    key: "_delete",
    value: function _delete() {
      var _getStateReference = getStateReference(this.app),
          tokenObservers = _getStateReference.tokenObservers;

      var _iterator2 = _createForOfIteratorHelper(tokenObservers),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tokenObserver = _step2.value;

          _removeTokenListener(this.app, tokenObserver.next);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return Promise.resolve();
    }
  }]);

  return AppCheckService;
}();

function factory(app, heartbeatServiceProvider) {
  return new AppCheckService(app, heartbeatServiceProvider);
}

function internalFactory(appCheck) {
  return {
    getToken: function getToken(forceRefresh) {
      return getToken$2(appCheck, forceRefresh);
    },
    addTokenListener: function addTokenListener(listener) {
      return _addTokenListener(appCheck, "INTERNAL"
      /* ListenerType.INTERNAL */
      , listener);
    },
    removeTokenListener: function removeTokenListener(listener) {
      return _removeTokenListener(appCheck.app, listener);
    }
  };
}

var name = "@firebase/app-check";
var version = "0.6.5";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js';
var RECAPTCHA_ENTERPRISE_URL = 'https://www.google.com/recaptcha/enterprise.js';

function initializeV3(app, siteKey) {
  var initialized = new Deferred();
  var state = getStateReference(app);
  state.reCAPTCHAState = {
    initialized: initialized
  };
  var divId = makeDiv(app);
  var grecaptcha = getRecaptcha(false);

  if (!grecaptcha) {
    loadReCAPTCHAV3Script(function () {
      var grecaptcha = getRecaptcha(false);

      if (!grecaptcha) {
        // it shouldn't happen.
        throw new Error('no recaptcha');
      }

      queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
    });
  } else {
    queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
  }

  return initialized.promise;
}

function initializeEnterprise(app, siteKey) {
  var initialized = new Deferred();
  var state = getStateReference(app);
  state.reCAPTCHAState = {
    initialized: initialized
  };
  var divId = makeDiv(app);
  var grecaptcha = getRecaptcha(true);

  if (!grecaptcha) {
    loadReCAPTCHAEnterpriseScript(function () {
      var grecaptcha = getRecaptcha(true);

      if (!grecaptcha) {
        // it shouldn't happen.
        throw new Error('no recaptcha');
      }

      queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
    });
  } else {
    queueWidgetRender(app, siteKey, grecaptcha, divId, initialized);
  }

  return initialized.promise;
}
/**
 * Add listener to render the widget and resolve the promise when
 * the grecaptcha.ready() event fires.
 */


function queueWidgetRender(app, siteKey, grecaptcha, container, initialized) {
  grecaptcha.ready(function () {
    // Invisible widgets allow us to set a different siteKey for each widget,
    // so we use them to support multiple apps
    renderInvisibleWidget(app, siteKey, grecaptcha, container);
    initialized.resolve(grecaptcha);
  });
}
/**
 * Add invisible div to page.
 */


function makeDiv(app) {
  var divId = "fire_app_check_".concat(app.name);
  var invisibleDiv = document.createElement('div');
  invisibleDiv.id = divId;
  invisibleDiv.style.display = 'none';
  document.body.appendChild(invisibleDiv);
  return divId;
}

function getToken$1(_x9) {
  return _getToken$2.apply(this, arguments);
}
/**
 *
 * @param app
 * @param container - Id of a HTML element.
 */


function _getToken$2() {
  _getToken$2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(app) {
    var reCAPTCHAState, recaptcha;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            ensureActivated(app); // ensureActivated() guarantees that reCAPTCHAState is set

            reCAPTCHAState = getStateReference(app).reCAPTCHAState;
            _context13.next = 4;
            return reCAPTCHAState.initialized.promise;

          case 4:
            recaptcha = _context13.sent;
            return _context13.abrupt("return", new Promise(function (resolve, _reject) {
              // Updated after initialization is complete.
              var reCAPTCHAState = getStateReference(app).reCAPTCHAState;
              recaptcha.ready(function () {
                resolve( // widgetId is guaranteed to be available if reCAPTCHAState.initialized.promise resolved.
                recaptcha.execute(reCAPTCHAState.widgetId, {
                  action: 'fire_app_check'
                }));
              });
            }));

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _getToken$2.apply(this, arguments);
}

function renderInvisibleWidget(app, siteKey, grecaptcha, container) {
  var widgetId = grecaptcha.render(container, {
    sitekey: siteKey,
    size: 'invisible',
    // Success callback - set state
    callback: function callback() {
      getStateReference(app).reCAPTCHAState.succeeded = true;
    },
    // Failure callback - set state
    'error-callback': function errorCallback() {
      getStateReference(app).reCAPTCHAState.succeeded = false;
    }
  });
  var state = getStateReference(app);
  state.reCAPTCHAState = Object.assign(Object.assign({}, state.reCAPTCHAState), {
    // state.reCAPTCHAState is set in the initialize()
    widgetId: widgetId
  });
}

function loadReCAPTCHAV3Script(onload) {
  var script = document.createElement('script');
  script.src = RECAPTCHA_URL;
  script.onload = onload;
  document.head.appendChild(script);
}

function loadReCAPTCHAEnterpriseScript(onload) {
  var script = document.createElement('script');
  script.src = RECAPTCHA_ENTERPRISE_URL;
  script.onload = onload;
  document.head.appendChild(script);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * App Check provider that can obtain a reCAPTCHA V3 token and exchange it
 * for an App Check token.
 *
 * @public
 */


var ReCaptchaV3Provider = /*#__PURE__*/function () {
  /**
   * Create a ReCaptchaV3Provider instance.
   * @param siteKey - ReCAPTCHA V3 siteKey.
   */
  function ReCaptchaV3Provider(_siteKey) {
    _classCallCheck(this, ReCaptchaV3Provider);

    this._siteKey = _siteKey;
    /**
     * Throttle requests on certain error codes to prevent too many retries
     * in a short time.
     */

    this._throttleData = null;
  }
  /**
   * Returns an App Check token.
   * @internal
   */


  _createClass(ReCaptchaV3Provider, [{
    key: "getToken",
    value: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _a, _b, _c, attestedClaimsToken, result;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                throwIfThrottled(this._throttleData); // Top-level `getToken()` has already checked that App Check is initialized
                // and therefore this._app and this._heartbeatServiceProvider are available.

                _context3.next = 3;
                return getToken$1(this._app)["catch"](function (_e) {
                  // reCaptcha.execute() throws null which is not very descriptive.
                  throw ERROR_FACTORY.create("recaptcha-error"
                  /* AppCheckError.RECAPTCHA_ERROR */
                  );
                });

              case 3:
                attestedClaimsToken = _context3.sent;

                if ((_a = getStateReference(this._app).reCAPTCHAState) === null || _a === void 0 ? void 0 : _a.succeeded) {
                  _context3.next = 6;
                  break;
                }

                throw ERROR_FACTORY.create("recaptcha-error"
                /* AppCheckError.RECAPTCHA_ERROR */
                );

              case 6:
                _context3.prev = 6;
                _context3.next = 9;
                return exchangeToken(getExchangeRecaptchaV3TokenRequest(this._app, attestedClaimsToken), this._heartbeatServiceProvider);

              case 9:
                result = _context3.sent;
                _context3.next = 20;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](6);

                if (!((_b = _context3.t0.code) === null || _b === void 0 ? void 0 : _b.includes("fetch-status-error"
                /* AppCheckError.FETCH_STATUS_ERROR */
                ))) {
                  _context3.next = 19;
                  break;
                }

                this._throttleData = setBackoff(Number((_c = _context3.t0.customData) === null || _c === void 0 ? void 0 : _c.httpStatus), this._throttleData);
                throw ERROR_FACTORY.create("throttled"
                /* AppCheckError.THROTTLED */
                , {
                  time: getDurationString(this._throttleData.allowRequestsAfter - Date.now()),
                  httpStatus: this._throttleData.httpStatus
                });

              case 19:
                throw _context3.t0;

              case 20:
                // If successful, clear throttle data.
                this._throttleData = null;
                return _context3.abrupt("return", result);

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 12]]);
      }));

      function getToken() {
        return _getToken.apply(this, arguments);
      }

      return getToken;
    }()
    /**
     * @internal
     */

  }, {
    key: "initialize",
    value: function initialize(app) {
      this._app = app;
      this._heartbeatServiceProvider = _getProvider(app, 'heartbeat');
      initializeV3(app, this._siteKey)["catch"](function () {
        /* we don't care about the initialization result */
      });
    }
    /**
     * @internal
     */

  }, {
    key: "isEqual",
    value: function isEqual(otherProvider) {
      if (otherProvider instanceof ReCaptchaV3Provider) {
        return this._siteKey === otherProvider._siteKey;
      } else {
        return false;
      }
    }
  }]);

  return ReCaptchaV3Provider;
}();
/**
 * App Check provider that can obtain a reCAPTCHA Enterprise token and exchange it
 * for an App Check token.
 *
 * @public
 */


var ReCaptchaEnterpriseProvider = /*#__PURE__*/function () {
  /**
   * Create a ReCaptchaEnterpriseProvider instance.
   * @param siteKey - reCAPTCHA Enterprise score-based site key.
   */
  function ReCaptchaEnterpriseProvider(_siteKey) {
    _classCallCheck(this, ReCaptchaEnterpriseProvider);

    this._siteKey = _siteKey;
    /**
     * Throttle requests on certain error codes to prevent too many retries
     * in a short time.
     */

    this._throttleData = null;
  }
  /**
   * Returns an App Check token.
   * @internal
   */


  _createClass(ReCaptchaEnterpriseProvider, [{
    key: "getToken",
    value: function () {
      var _getToken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _a, _b, _c, attestedClaimsToken, result;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                throwIfThrottled(this._throttleData); // Top-level `getToken()` has already checked that App Check is initialized
                // and therefore this._app and this._heartbeatServiceProvider are available.

                _context4.next = 3;
                return getToken$1(this._app)["catch"](function (_e) {
                  // reCaptcha.execute() throws null which is not very descriptive.
                  throw ERROR_FACTORY.create("recaptcha-error"
                  /* AppCheckError.RECAPTCHA_ERROR */
                  );
                });

              case 3:
                attestedClaimsToken = _context4.sent;

                if ((_a = getStateReference(this._app).reCAPTCHAState) === null || _a === void 0 ? void 0 : _a.succeeded) {
                  _context4.next = 6;
                  break;
                }

                throw ERROR_FACTORY.create("recaptcha-error"
                /* AppCheckError.RECAPTCHA_ERROR */
                );

              case 6:
                _context4.prev = 6;
                _context4.next = 9;
                return exchangeToken(getExchangeRecaptchaEnterpriseTokenRequest(this._app, attestedClaimsToken), this._heartbeatServiceProvider);

              case 9:
                result = _context4.sent;
                _context4.next = 20;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4["catch"](6);

                if (!((_b = _context4.t0.code) === null || _b === void 0 ? void 0 : _b.includes("fetch-status-error"
                /* AppCheckError.FETCH_STATUS_ERROR */
                ))) {
                  _context4.next = 19;
                  break;
                }

                this._throttleData = setBackoff(Number((_c = _context4.t0.customData) === null || _c === void 0 ? void 0 : _c.httpStatus), this._throttleData);
                throw ERROR_FACTORY.create("throttled"
                /* AppCheckError.THROTTLED */
                , {
                  time: getDurationString(this._throttleData.allowRequestsAfter - Date.now()),
                  httpStatus: this._throttleData.httpStatus
                });

              case 19:
                throw _context4.t0;

              case 20:
                // If successful, clear throttle data.
                this._throttleData = null;
                return _context4.abrupt("return", result);

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 12]]);
      }));

      function getToken() {
        return _getToken2.apply(this, arguments);
      }

      return getToken;
    }()
    /**
     * @internal
     */

  }, {
    key: "initialize",
    value: function initialize(app) {
      this._app = app;
      this._heartbeatServiceProvider = _getProvider(app, 'heartbeat');
      initializeEnterprise(app, this._siteKey)["catch"](function () {
        /* we don't care about the initialization result */
      });
    }
    /**
     * @internal
     */

  }, {
    key: "isEqual",
    value: function isEqual(otherProvider) {
      if (otherProvider instanceof ReCaptchaEnterpriseProvider) {
        return this._siteKey === otherProvider._siteKey;
      } else {
        return false;
      }
    }
  }]);

  return ReCaptchaEnterpriseProvider;
}();
/**
 * Custom provider class.
 * @public
 */


var CustomProvider = /*#__PURE__*/function () {
  function CustomProvider(_customProviderOptions) {
    _classCallCheck(this, CustomProvider);

    this._customProviderOptions = _customProviderOptions;
  }
  /**
   * @internal
   */


  _createClass(CustomProvider, [{
    key: "getToken",
    value: function () {
      var _getToken3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var customToken, issuedAtTimeSeconds, issuedAtTimeMillis;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._customProviderOptions.getToken();

              case 2:
                customToken = _context5.sent;
                // Try to extract IAT from custom token, in case this token is not
                // being newly issued. JWT timestamps are in seconds since epoch.
                issuedAtTimeSeconds = issuedAtTime(customToken.token); // Very basic validation, use current timestamp as IAT if JWT
                // has no `iat` field or value is out of bounds.

                issuedAtTimeMillis = issuedAtTimeSeconds !== null && issuedAtTimeSeconds < Date.now() && issuedAtTimeSeconds > 0 ? issuedAtTimeSeconds * 1000 : Date.now();
                return _context5.abrupt("return", Object.assign(Object.assign({}, customToken), {
                  issuedAtTimeMillis: issuedAtTimeMillis
                }));

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getToken() {
        return _getToken3.apply(this, arguments);
      }

      return getToken;
    }()
    /**
     * @internal
     */

  }, {
    key: "initialize",
    value: function initialize(app) {
      this._app = app;
    }
    /**
     * @internal
     */

  }, {
    key: "isEqual",
    value: function isEqual(otherProvider) {
      if (otherProvider instanceof CustomProvider) {
        return this._customProviderOptions.getToken.toString() === otherProvider._customProviderOptions.getToken.toString();
      } else {
        return false;
      }
    }
  }]);

  return CustomProvider;
}();
/**
 * Set throttle data to block requests until after a certain time
 * depending on the failed request's status code.
 * @param httpStatus - Status code of failed request.
 * @param throttleData - `ThrottleData` object containing previous throttle
 * data state.
 * @returns Data about current throttle state and expiration time.
 */


function setBackoff(httpStatus, throttleData) {
  /**
   * Block retries for 1 day for the following error codes:
   *
   * 404: Likely malformed URL.
   *
   * 403:
   * - Attestation failed
   * - Wrong API key
   * - Project deleted
   */
  if (httpStatus === 404 || httpStatus === 403) {
    return {
      backoffCount: 1,
      allowRequestsAfter: Date.now() + ONE_DAY,
      httpStatus: httpStatus
    };
  } else {
    /**
     * For all other error codes, the time when it is ok to retry again
     * is based on exponential backoff.
     */
    var backoffCount = throttleData ? throttleData.backoffCount : 0;
    var backoffMillis = calculateBackoffMillis(backoffCount, 1000, 2);
    return {
      backoffCount: backoffCount + 1,
      allowRequestsAfter: Date.now() + backoffMillis,
      httpStatus: httpStatus
    };
  }
}

function throwIfThrottled(throttleData) {
  if (throttleData) {
    if (Date.now() - throttleData.allowRequestsAfter <= 0) {
      // If before, throw.
      throw ERROR_FACTORY.create("throttled"
      /* AppCheckError.THROTTLED */
      , {
        time: getDurationString(throttleData.allowRequestsAfter - Date.now()),
        httpStatus: throttleData.httpStatus
      });
    }
  }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Activate App Check for the given app. Can be called only once per app.
 * @param app - the {@link @firebase/app#FirebaseApp} to activate App Check for
 * @param options - App Check initialization options
 * @public
 */


function initializeAppCheck() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();
  var options = arguments.length > 1 ? arguments[1] : undefined;
  app = getModularInstance(app);

  var provider = _getProvider(app, 'app-check'); // Ensure initializeDebugMode() is only called once.


  if (!getDebugState().initialized) {
    initializeDebugMode();
  } // Log a message containing the debug token when `initializeAppCheck()`
  // is called in debug mode.


  if (isDebugMode()) {
    // Do not block initialization to get the token for the message.
    void getDebugToken().then(function (token) {
      return (// Not using logger because I don't think we ever want this accidentally hidden.
        console.log("App Check debug token: ".concat(token, ". You will need to add it to your app's App Check settings in the Firebase console for it to work."))
      );
    });
  }

  if (provider.isInitialized()) {
    var existingInstance = provider.getImmediate();
    var initialOptions = provider.getOptions();

    if (initialOptions.isTokenAutoRefreshEnabled === options.isTokenAutoRefreshEnabled && initialOptions.provider.isEqual(options.provider)) {
      return existingInstance;
    } else {
      throw ERROR_FACTORY.create("already-initialized"
      /* AppCheckError.ALREADY_INITIALIZED */
      , {
        appName: app.name
      });
    }
  }

  var appCheck = provider.initialize({
    options: options
  });

  _activate(app, options.provider, options.isTokenAutoRefreshEnabled); // If isTokenAutoRefreshEnabled is false, do not send any requests to the
  // exchange endpoint without an explicit call from the user either directly
  // or through another Firebase library (storage, functions, etc.)


  if (getStateReference(app).isTokenAutoRefreshEnabled) {
    // Adding a listener will start the refresher and fetch a token if needed.
    // This gets a token ready and prevents a delay when an internal library
    // requests the token.
    // Listener function does not need to do anything, its base functionality
    // of calling getToken() already fetches token and writes it to memory/storage.
    _addTokenListener(appCheck, "INTERNAL"
    /* ListenerType.INTERNAL */
    , function () {});
  }

  return appCheck;
}
/**
 * Activate App Check
 * @param app - Firebase app to activate App Check for.
 * @param provider - reCAPTCHA v3 provider or
 * custom token provider.
 * @param isTokenAutoRefreshEnabled - If true, the SDK automatically
 * refreshes App Check tokens as needed. If undefined, defaults to the
 * value of `app.automaticDataCollectionEnabled`, which defaults to
 * false and can be set in the app config.
 */


function _activate(app, provider, isTokenAutoRefreshEnabled) {
  // Create an entry in the APP_CHECK_STATES map. Further changes should
  // directly mutate this object.
  var state = setInitialState(app, Object.assign({}, DEFAULT_STATE));
  state.activated = true;
  state.provider = provider; // Read cached token from storage if it exists and store it in memory.

  state.cachedTokenPromise = readTokenFromStorage(app).then(function (cachedToken) {
    if (cachedToken && isValid(cachedToken)) {
      state.token = cachedToken; // notify all listeners with the cached token

      notifyTokenListeners(app, {
        token: cachedToken.token
      });
    }

    return cachedToken;
  }); // Use value of global `automaticDataCollectionEnabled` (which
  // itself defaults to false if not specified in config) if
  // `isTokenAutoRefreshEnabled` param was not provided by user.

  state.isTokenAutoRefreshEnabled = isTokenAutoRefreshEnabled === undefined ? app.automaticDataCollectionEnabled : isTokenAutoRefreshEnabled;
  state.provider.initialize(app);
}
/**
 * Set whether App Check will automatically refresh tokens as needed.
 *
 * @param appCheckInstance - The App Check service instance.
 * @param isTokenAutoRefreshEnabled - If true, the SDK automatically
 * refreshes App Check tokens as needed. This overrides any value set
 * during `initializeAppCheck()`.
 * @public
 */


function setTokenAutoRefreshEnabled(appCheckInstance, isTokenAutoRefreshEnabled) {
  var app = appCheckInstance.app;
  var state = getStateReference(app); // This will exist if any product libraries have called
  // `addTokenListener()`

  if (state.tokenRefresher) {
    if (isTokenAutoRefreshEnabled === true) {
      state.tokenRefresher.start();
    } else {
      state.tokenRefresher.stop();
    }
  }

  state.isTokenAutoRefreshEnabled = isTokenAutoRefreshEnabled;
}
/**
 * Get the current App Check token. Attaches to the most recent
 * in-flight request if one is present. Returns null if no token
 * is present and no token requests are in-flight.
 *
 * @param appCheckInstance - The App Check service instance.
 * @param forceRefresh - If true, will always try to fetch a fresh token.
 * If false, will use a cached token if found in storage.
 * @public
 */


function getToken(_x10, _x11) {
  return _getToken4.apply(this, arguments);
}
/**
 * Wraps `addTokenListener`/`removeTokenListener` methods in an `Observer`
 * pattern for public use.
 */


function _getToken4() {
  _getToken4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(appCheckInstance, forceRefresh) {
    var result;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return getToken$2(appCheckInstance, forceRefresh);

          case 2:
            result = _context14.sent;

            if (!result.error) {
              _context14.next = 5;
              break;
            }

            throw result.error;

          case 5:
            return _context14.abrupt("return", {
              token: result.token
            });

          case 6:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _getToken4.apply(this, arguments);
}

function onTokenChanged(appCheckInstance, onNextOrObserver, onError,
/**
 * NOTE: Although an `onCompletion` callback can be provided, it will
 * never be called because the token stream is never-ending.
 * It is added only for API consistency with the observer pattern, which
 * we follow in JS APIs.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
onCompletion) {
  var nextFn = function nextFn() {};

  var errorFn = function errorFn() {};

  if (onNextOrObserver.next != null) {
    nextFn = onNextOrObserver.next.bind(onNextOrObserver);
  } else {
    nextFn = onNextOrObserver;
  }

  if (onNextOrObserver.error != null) {
    errorFn = onNextOrObserver.error.bind(onNextOrObserver);
  } else if (onError) {
    errorFn = onError;
  }

  _addTokenListener(appCheckInstance, "EXTERNAL"
  /* ListenerType.EXTERNAL */
  , nextFn, errorFn);

  return function () {
    return _removeTokenListener(appCheckInstance.app, nextFn);
  };
}
/**
 * Firebase App Check
 *
 * @packageDocumentation
 */


var APP_CHECK_NAME = 'app-check';
var APP_CHECK_NAME_INTERNAL = 'app-check-internal';

function registerAppCheck() {
  // The public interface
  _registerComponent(new Component(APP_CHECK_NAME, function (container) {
    // getImmediate for FirebaseApp will always succeed
    var app = container.getProvider('app').getImmediate();
    var heartbeatServiceProvider = container.getProvider('heartbeat');
    return factory(app, heartbeatServiceProvider);
  }, "PUBLIC"
  /* ComponentType.PUBLIC */
  ).setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  )
  /**
   * Initialize app-check-internal after app-check is initialized to make AppCheck available to
   * other Firebase SDKs
   */
  .setInstanceCreatedCallback(function (container, _identifier, _appcheckService) {
    container.getProvider(APP_CHECK_NAME_INTERNAL).initialize();
  })); // The internal interface used by other Firebase products


  _registerComponent(new Component(APP_CHECK_NAME_INTERNAL, function (container) {
    var appCheck = container.getProvider('app-check').getImmediate();
    return internalFactory(appCheck);
  }, "PUBLIC"
  /* ComponentType.PUBLIC */
  ).setInstantiationMode("EXPLICIT"
  /* InstantiationMode.EXPLICIT */
  ));

  registerVersion(name, version);
}

registerAppCheck();
export { CustomProvider, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider, getToken, initializeAppCheck, onTokenChanged, setTokenAutoRefreshEnabled };